import React, { useEffect } from "react";

export default function PdfViewer(props) {
  useEffect(() => {
    window.scroll(0, 230);
  }, []);

  return (
    <div className="pdf-viewer" id="pdfViewer">
      <div className="Header">
        <span className="cat-title">{localStorage.getItem("pdfTitle")}</span>
      </div>
      <div style={{ position: "relative", height: "100%" }}>
        {/* <div
          style={{
            backgroundColor: "#fff",
            height: "50px",
            width: "50px",
            position: "absolute",
            top: "7px",
            zIndex: "999998",œ
            opacity: "0.1",
            left: "calc(100% - 53px)",
          }}
        ></div> */}
        <object
          data={`${localStorage.getItem("pdfLink")}#toolbar=0`}
          type="application/pdf"
          width="100%"
          height="100%"
          style={{
            height: "89vh",
          }}
        ></object>
        {/* <iframe
          src={`https://docs.google.com/gview?url=${localStorage.getItem("pdfLink")}&embedded=true`}
          style={{ width: "100%", height: "89vh" }}
          frameBorder="0" 
        ></iframe>*/}
      </div>
    </div>
  );
}
